module.exports = __webpack_public_path__ + "img/218.a535e58f.jpg";